import { render, staticRenderFns } from "./GED.vue?vue&type=template&id=cd733072&scoped=true"
import script from "./GED.vue?vue&type=script&lang=js"
export * from "./GED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd733072",
  null
  
)

export default component.exports